import React from 'react';
import * as PropTypes from 'prop-types';
import { LoadingSpinner } from 'components/loading-spinner';

export const NewThumbnail = ({ newThumbId, newThumbUrl }) => {
  if (newThumbId) {
    return newThumbUrl ? <img src={newThumbUrl} alt="New Thumbnail" data-e2e="new-thumbnail" /> : <LoadingSpinner />;
  }
  return null;
};

NewThumbnail.propTypes = {
  newThumbId: PropTypes.number,
  newThumbUrl: PropTypes.string,
};
